var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-article"},[(_vm.data.articleContent)?_c('div',{staticClass:"has-articleContent",domProps:{"innerHTML":_vm._s(_vm.data.articleContent)}}):_c('div',{staticClass:"no-articleContent"},[_vm._v("点击编辑图文内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }